import clsx from 'clsx';
import React from 'react';
export const AvatarPlaceholder = (props) => {
    const { label, className = 'text-3xl md:text-4xl' } = props;
    return (React.createElement("span", { className: clsx(className, 'rounded-full bg-app-slate-rhythm flex-shrink-0 flex items-center justify-center text-white font-medium uppercase whitespace-nowrap') }, label));
};
